import { WishlistItemSchema } from "@apps/wishlist/schemas/WishlistItemSchema";
import { object } from "superstruct";

export const MoveItemResponseSchema = object({
    movedItem: WishlistItemSchema,
});
